import { getJSON } from '@folklore/fetch';
import { useEffect, useState } from 'react';

import addTrackingCodesToStory from '../lib/addTrackingCodesToStory';

import { useAnalytics } from '../contexts/AnalyticsContext';

const cache = new Map();

export function useMicromagStory(initialMicromag = null) {
    const { googleAnalyticsIds = null } = useAnalytics();

    const [micromag, setMicromag] = useState(initialMicromag);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (initialMicromag === null) {
            return;
        }
        const { url = null } = initialMicromag || {};
        const previous = url !== null ? cache.get(url) || null : null;
        if (previous === null && url !== null) {
            setLoading(true);
            getJSON(url)
                .then((newMicromag) => {
                    const newValue = {
                        ...micromag,
                        story: addTrackingCodesToStory(newMicromag, googleAnalyticsIds),
                    };
                    cache.set(url, newValue);
                    setMicromag(newValue);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        } else {
            setMicromag(previous || initialMicromag);
        }
    }, [initialMicromag, setLoading, setMicromag, googleAnalyticsIds]);

    return {
        story: micromag?.story || null,
        loading,
    };
}

export default useMicromagStory;
